/* eslint-disable @typescript-eslint/no-explicit-any,@typescript-eslint/ban-types */
import { getInjectedData } from "../injector";
const NO_VALUE = Symbol("no-value");
export const Inject = (props) => (target, propertyName, parameterIndex) => {
    if (typeof propertyName === "symbol") {
        throw new Error("Inject decorator can only be used on class properties");
    }
    let propertyType;
    if (parameterIndex === undefined) {
        propertyType = Reflect.getMetadata("design:type", target, propertyName);
    }
    else {
        const types = Reflect.getMetadata("design:paramtypes", target, propertyName);
        propertyType = types[parameterIndex];
    }
    if (typeof props === "function") {
        props = {
            provider: props,
        };
    }
    const retrievalProvider = props?.provider ||
        ((container) => {
            return container.getMaybePromise(propertyType);
        });
    const data = getInjectedData(parameterIndex === undefined ? target : target.prototype);
    if (parameterIndex === undefined) {
        let val = NO_VALUE;
        const provider = (container, target) => {
            const field = {
                fieldType: "property",
                name: propertyName,
                defaultValue: target[propertyName],
                target,
                type: propertyType,
                getValue: () => val,
            };
            Object.defineProperty(target, propertyName, {
                get() {
                    if (val === NO_VALUE) {
                        throw new Error(`Property ${propertyName} has not been injected`);
                    }
                    return val;
                },
                set(newVal) {
                    val = newVal;
                },
            });
            const retrieved = retrievalProvider(container, field);
            if (retrieved instanceof Promise) {
                return retrieved.then((newVal) => (val = newVal));
            }
            else {
                val = retrieved;
            }
        };
        data.properties.push(provider);
    }
    else {
        if (propertyType === target) {
            throw new Error("Cannot inject self in constructor");
        }
        data.parameters[parameterIndex] = (container, target) => {
            const field = {
                fieldType: "parameter",
                index: parameterIndex,
                target,
                type: propertyType,
            };
            return retrievalProvider(container, field);
        };
    }
};
